module.exports = __webpack_public_path__ + "images/171_4096.jpg";